import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.white,
  textColor: colors.graphite,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default pencilBanner;